/** @format */

import {Typography} from '@mui/material';
import {ArrowForward, ArrowDownward} from '@mui/icons-material';

import {
  ValueChangeCellHorizontal,
  ValueChangeCellVertical,
  ValueChangeCellArrowContainer,
  ValueChangeCellAfterText,
  ValueChangeCellArrow,
} from '../../style';

interface ArrowValueDisplayProps {
  beforeText: string;
  afterText: string;
  isHorizontal: boolean;
}

const ArrowValueDisplay = ({beforeText, afterText, isHorizontal}: ArrowValueDisplayProps) => {
  const Container = isHorizontal ? ValueChangeCellHorizontal : ValueChangeCellVertical;
  const ArrowIcon = isHorizontal ? ArrowForward : ArrowDownward;

  return (
    <Container>
      <Typography>{beforeText}</Typography>
      {isHorizontal ? (
        <ValueChangeCellArrow as={ArrowIcon} />
      ) : (
        <ValueChangeCellArrowContainer>
          <ValueChangeCellArrow as={ArrowIcon} />
        </ValueChangeCellArrowContainer>
      )}
      <ValueChangeCellAfterText>
        <Typography>{afterText}</Typography>
      </ValueChangeCellAfterText>
    </Container>
  );
};

export default ArrowValueDisplay;
